import { AzureIconUrl } from "@p0security/shared/integrations/constants";
import { AzureComponents } from "@p0security/shared/integrations/resources/azure/components";
import { Typography } from "antd";
import { useCallback } from "react";
import { Link } from "react-router-dom";

import { Install, InstallProps } from "../Install/Install";
import { azureInstaller } from "./install";

const AzurePreamble = (
  <>
    <Typography.Text strong>
      Recommended components by use case:
    </Typography.Text>
    <ul className="preamble-list">
      <li>
        <strong>Just-in-time access:</strong>{" "}
        <Link to="./azure-app">App Registration</Link> and{" "}
        <Link to="./iam-write">IAM Management</Link>
      </li>
      <li>
        <strong>SSH via Bastion:</strong>{" "}
        <Link to="./bastion-host">Bastion Host</Link>
      </li>
    </ul>
  </>
);

export const Azure = (
  props: Pick<
    InstallProps<typeof AzureComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(
    (componentKey: string) =>
      componentKey === "azure-app" ? "app" : "subscription",
    []
  );
  const identifier = useCallback(
    (componentKey: string) => (componentKey === "azure-app" ? "Name" : "ID"),
    []
  );

  return (
    <Install<typeof AzureComponents>
      components={AzureComponents}
      installer={azureInstaller}
      integration="azure"
      itemKind={itemKind}
      identifier={identifier}
      logo={AzureIconUrl}
      preamble={AzurePreamble}
      title={"Microsoft Azure"}
      {...props}
    />
  );
};
